/**
 * Branding Configuration
 * Direct references to Positive Zero images and colors
 */

// Base URL for Positive Zero website
export const POSITIVEZERO_BASE_URL = 'https://positivezero.com';

export const BRANDING = {
  // Company Information
  company: {
    name: 'SR Enterprise',
    fullName: 'SR Enterprise Solutions',
    website: POSITIVEZERO_BASE_URL,
    email: 'takecharge@positivezero.com',
    phone: '+971 XX XXX XXXX',
    description: 'Enterprise IoT device management and analytics platform.',
  },

  // Images directly from Positive Zero
  images: {
    // Background images from Positive Zero
    heroBackground: `${POSITIVEZERO_BASE_URL}/wp-content/uploads/hero-background.jpg`,
    bannerBackground: `${POSITIVEZERO_BASE_URL}/wp-content/uploads/banner-background.jpg`,
    dashboardBackground: `${POSITIVEZERO_BASE_URL}/wp-content/uploads/dashboard-bg.jpg`,
    
    // Logo and branding
    logo: `${POSITIVEZERO_BASE_URL}/wp-content/uploads/logo.png`,
    favicon: `${POSITIVEZERO_BASE_URL}/wp-content/uploads/favicon.png`,
    
    // Banners and promotional images - using data URIs to avoid external dependencies
    promoBanner: 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwMCIgaGVpZ2h0PSIzMDAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHJlY3Qgd2lkdGg9IjEwMCUiIGhlaWdodD0iMTAwJSIgZmlsbD0iI0ZGMDBDRCIvPjx0ZXh0IHg9IjUwJSIgeT0iNTAlIiBmb250LWZhbWlseT0iQXJpYWwiIGZvbnQtc2l6ZT0iNDgiIGZpbGw9IiNGRkZGRkYiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGR5PSIuM2VtIj5XZWxjb21lIHRvIFNSIEVudGVycHJpc2U8L3RleHQ+PC9zdmc+',
    welcomeBanner: 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwMCIgaGVpZ2h0PSIzMDAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHJlY3Qgd2lkdGg9IjEwMCUiIGhlaWdodD0iMTAwJSIgZmlsbD0iIzYyMDBCNiIvPjx0ZXh0IHg9IjUwJSIgeT0iNTAlIiBmb250LWZhbWlseT0iQXJpYWwiIGZvbnQtc2l6ZT0iNDgiIGZpbGw9IiNGRkZGRkYiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGR5PSIuM2VtIj5TUiBFbnRlcnByaXNlIERhc2hib2FyZDwvdGV4dD48L3N2Zz4=',
    
    // Service images - using data URIs
    service1: 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAwIiBoZWlnaHQ9IjQwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiBmaWxsPSIjRkYwNkNEIi8+PHRleHQgeD0iNTAlIiB5PSI1MCUiIGZvbnQtZmFtaWx5PSJBcmlhbCIgZm9udC1zaXplPSIzNiIgZmlsbD0iI0ZGRkZGRiIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZHk9Ii4zZW0iPkRldmljZSBNYW5hZ2VtZW50PC90ZXh0Pjwvc3ZnPg==',
    service2: 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAwIiBoZWlnaHQ9IjQwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiBmaWxsPSIjNjIwMEI2Ii8+PHRleHQgeD0iNTAlIiB5PSI1MCUiIGZvbnQtZmFtaWx5PSJBcmlhbCIgZm9udC1zaXplPSIzNiIgZmlsbD0iI0ZGRkZGRiIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZHk9Ii4zZW0iPkFuYWx5dGljczwvdGV4dD48L3N2Zz4=',
    service3: 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAwIiBoZWlnaHQ9IjQwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiBmaWxsPSIjMDlCRkM5Ii8+PHRleHQgeD0iNTAlIiB5PSI1MCUiIGZvbnQtZmFtaWx5PSJBcmlhbCIgZm9udC1zaXplPSIzNiIgZmlsbD0iI0ZGRkZGRiIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZHk9Ii4zZW0iPlNlY3VyaXR5PC90ZXh0Pjwvc3ZnPg==',
    
    // Fallback
    placeholder: 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAwIiBoZWlnaHQ9IjMwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiBmaWxsPSIjRURFQUY0Ii8+PHRleHQgeD0iNTAlIiB5PSI1MCUiIGZvbnQtZmFtaWx5PSJBcmlhbCIgZm9udC1zaXplPSIyNCIgZmlsbD0iIzY0NUU3QSIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZHk9Ii4zZW0iPlNSIEVudGVycHJpc2U8L3RleHQ+PC9zdmc+',
  },

  // Colors from exact color scheme
  colors: {
    primary: '#FF06CD', // RGB(255, 6, 205) - Bright fuchsia pink
    secondary: '#6200B6', // RGB(98, 0, 182) - Deep purple
    accent: {
      blueGrey: '#7698B3',
      orange: '#FF8400',
      teal: '#09BFC9',
      blue: '#0892D0',
      darkIndigo: '#2D0363',
      magenta: '#AA0993',
    },
    background: '#EDEAF4', // Light gray purple
    text: '#0C0023', // Dark blue-black
    textLight: '#645E7A', // Dark gray purple
  },

  // Services/Features
  services: [
    {
      id: 1,
      name: 'Device Management',
      description: 'Monitor and manage all your IoT devices from a single dashboard',
      icon: 'Devices',
      image: 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAwIiBoZWlnaHQ9IjQwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiBmaWxsPSIjRkYwNkNEIi8+PHRleHQgeD0iNTAlIiB5PSI1MCUiIGZvbnQtZmFtaWx5PSJBcmlhbCIgZm9udC1zaXplPSIzNiIgZmlsbD0iI0ZGRkZGRiIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZHk9Ii4zZW0iPkRldmljZSBNYW5hZ2VtZW50PC90ZXh0Pjwvc3ZnPg==',
      link: '/devices',
    },
    {
      id: 2,
      name: 'Real-time Analytics',
      description: 'Get insights into device performance and usage patterns',
      icon: 'Analytics',
      image: 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAwIiBoZWlnaHQ9IjQwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiBmaWxsPSIjNjIwMEI2Ii8+PHRleHQgeD0iNTAlIiB5PSI1MCUiIGZvbnQtZmFtaWx5PSJBcmlhbCIgZm9udC1zaXplPSIzNiIgZmlsbD0iI0ZGRkZGRiIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZHk9Ii4zZW0iPkFuYWx5dGljczwvdGV4dD48L3N2Zz4=',
      link: '/analytics',
    },
    {
      id: 3,
      name: 'Security & Monitoring',
      description: 'Advanced security features and 24/7 monitoring capabilities',
      icon: 'Security',
      image: 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAwIiBoZWlnaHQ9IjQwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiBmaWxsPSIjMDlCRkM5Ii8+PHRleHQgeD0iNTAlIiB5PSI1MCUiIGZvbnQtZmFtaWx5PSJBcmlhbCIgZm9udC1zaXplPSIzNiIgZmlsbD0iI0ZGRkZGRiIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZHk9Ii4zZW0iPlNlY3VyaXR5PC90ZXh0Pjwvc3ZnPg==',
      link: '/settings',
    },
  ],

  // Promotional Content
  promotions: [
    {
      id: 1,
      title: 'Welcome to SR Enterprise Dashboard',
      description: 'Monitor your IoT devices, analyze performance, and manage your fleet all in one place.',
      cta: 'Get Started',
      ctaLink: '/dashboard',
      backgroundImage: 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwMCIgaGVpZ2h0PSIzMDAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHJlY3Qgd2lkdGg9IjEwMCUiIGhlaWdodD0iMTAwJSIgZmlsbD0iI0ZGMDBDRCIvPjx0ZXh0IHg9IjUwJSIgeT0iNTAlIiBmb250LWZhbWlseT0iQXJpYWwiIGZvbnQtc2l6ZT0iNDgiIGZpbGw9IiNGRkZGRkYiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGR5PSIuM2VtIj5XZWxjb21lIHRvIFNSIEVudGVycHJpc2U8L3RleHQ+PC9zdmc+',
      active: true,
    },
  ],

  // Footer Links
  footer: {
    quickLinks: [
      { label: 'About Us', path: `${POSITIVEZERO_BASE_URL}/about` },
      { label: 'Services', path: `${POSITIVEZERO_BASE_URL}/services` },
      { label: 'Contact', path: `${POSITIVEZERO_BASE_URL}/contact` },
      { label: 'Blog', path: `${POSITIVEZERO_BASE_URL}/blog` },
    ],
    support: [
      { label: 'Documentation', path: `${POSITIVEZERO_BASE_URL}/docs` },
      { label: 'API Reference', path: `${POSITIVEZERO_BASE_URL}/api` },
      { label: 'Help Center', path: `${POSITIVEZERO_BASE_URL}/help` },
      { label: 'Contact Support', path: `${POSITIVEZERO_BASE_URL}/support` },
    ],
    legal: [
      { label: 'Privacy Policy', path: `${POSITIVEZERO_BASE_URL}/privacy-policy` },
      { label: 'Terms of Service', path: `${POSITIVEZERO_BASE_URL}/terms-of-service` },
      { label: 'Cookie Policy', path: `${POSITIVEZERO_BASE_URL}/cookie-policy` },
    ],
  },
};

/**
 * Helper function to get image URL from Positive Zero
 */
export const getImageUrl = (imagePath, fallback = BRANDING.images.placeholder) => {
  if (!imagePath) return fallback;
  
  // If it's already a full URL, return it
  if (imagePath.startsWith('http')) return imagePath;
  
  // If it starts with /, prepend Positive Zero domain
  if (imagePath.startsWith('/')) {
    return `${POSITIVEZERO_BASE_URL}${imagePath}`;
  }
  
  // Otherwise, assume it's a WordPress upload path
  return `${POSITIVEZERO_BASE_URL}/wp-content/uploads/${imagePath}`;
};

export default BRANDING;
